import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/use-queries";
import { PageLoader } from "@/components/LogoLoader";

export default function RequireAuth() {
  const { data: user, isLoading, error } = useMe();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader />;
  }

  // If error (401) or no user data, redirect to login
  if (error || !user) {
    // Redirect to login page, but save the current location they were trying to go to
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
